/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Message_ProcessedInputs */

const en_sync_message_processed = /** @type {(inputs: Sync_Message_ProcessedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted`)
};

/**
* | output |
* | --- |
* | "Accepted" |
*
* @param {Sync_Message_ProcessedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sync_message_processed = /** @type {((inputs?: Sync_Message_ProcessedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Message_ProcessedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_sync_message_processed(inputs)
});